module.exports = __webpack_public_path__ + "static/media/LocateUs.2524cf6d.svg";